var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIrmIconCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4333 13.067L12.4077 13.067L14.8538 15.513C15.2705 15.9297 15.2705 16.6047 14.8538 17.0215C14.4371 17.4382 13.762 17.4382 13.3453 17.0215L9.07971 12.7559C8.98069 12.6572 8.90211 12.539 8.84789 12.4076C8.74015 12.147 8.74015 11.8536 8.84789 11.593C8.90229 11.4616 8.98069 11.3434 9.07971 11.2447L13.3453 6.97913C13.762 6.56242 14.4371 6.56242 14.8538 6.97913C15.0621 7.18748 15.1663 7.46055 15.1663 7.73344C15.1663 8.00633 15.0621 8.2794 14.8538 8.48758L12.4077 10.9336L19.4333 10.9336C20.023 10.9336 20.5 11.4108 20.5 12.0003C20.5 12.5898 20.0232 13.067 19.4333 13.067ZM6.63352 6.66654L6.63334 17.3341V18.4008C6.63334 18.9903 6.15618 19.4675 5.56667 19.4675C4.97716 19.4675 4.5 18.9905 4.5 18.4008L4.5 5.59987C4.5 5.01036 4.97698 4.5332 5.56685 4.5332C6.15636 4.5332 6.63352 5.01036 6.63352 5.59987C6.63352 5.83295 6.63349 6.04846 6.63347 6.22386C6.63343 6.4921 6.63341 6.66654 6.63352 6.66654Z",
    fill: "#6F7687"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrmIconCollapse);
export default __webpack_public_path__ + "static/media/irm-icon-collapse.bec103ad3b687053e17051cafb062818.svg";
export { ForwardRef as ReactComponent };